import httpClient from '../httpClient';

export default {
  getContent(type) {
    return httpClient('v0.3').get('/custom_contents', {
      params: { type: type }
    });
  }
};
